import { useState } from "react";
/* Copie synchronisée avec reporttype/hapivot_types_documents_rgpd.json (page dashboard HTML). */
import hapivotTypesJson from "./data/hapivot_types_documents_rgpd.json";

/** Clé utilisée uniquement par la page statique reporttype/hapivot_dashboard_couverture.html (sans API). */
export const RGPD_DOC_TYPES_STORAGE_KEY = "rgpd_suite_doc_types_enabled";

/** Identifiants JSON → codes utilisés dans les preuves (formulaire). */
export const JSON_ID_TO_APP_CODE = {
  PIA_DPIA: "PIA",
  DPA: "DPA",
  SCC: "SCC",
  TIA: "TIA",
  BCR: "BCR",
  LIA: "LIA",
  ROPA: "ROPA",
};

export const DOC_TYPES = [
  { code: "DPA", label: "DPA", color: "#7c3aed", bg: "#f5f3ff", border: "#c4b5fd", desc: "Data Processing Agreement — Contrat encadrant la relation responsable de traitement / sous-traitant (art. 28 RGPD). Obligatoire avec tout prestataire traitant des données personnelles pour votre compte." },
  { code: "PIA", label: "PIA/DPIA", color: "#dc2626", bg: "#fef2f2", border: "#fca5a5", desc: "Privacy / Data Protection Impact Assessment — Analyse d'impact obligatoire pour les traitements à risque élevé (art. 35 RGPD). Ex : vidéosurveillance, profilage, données sensibles." },
  { code: "SCC", label: "SCC", color: "#0284c7", bg: "#e0f2fe", border: "#7dd3fc", desc: "Standard Contractual Clauses — Clauses contractuelles types de la Commission européenne pour encadrer les transferts de données hors UE/EEE vers des pays sans décision d'adéquation." },
  { code: "TIA", label: "TIA", color: "#0891b2", bg: "#ecfeff", border: "#67e8f9", desc: "Transfer Impact Assessment — Évaluation complémentaire aux SCC permettant de vérifier que les données transférées hors UE bénéficient d'un niveau de protection équivalent au RGPD dans le pays destinataire." },
  { code: "BCR", label: "BCR", color: "#7e22ce", bg: "#faf5ff", border: "#d8b4fe", desc: "Binding Corporate Rules — Règles d'entreprise contraignantes approuvées par une autorité de contrôle, permettant aux groupes internationaux de transférer des données entre entités hors UE de façon licite." },
  { code: "LIA", label: "LIA", color: "#15803d", bg: "#f0fdf4", border: "#86efac", desc: "Legitimate Interest Assessment — Document justifiant le recours à l'intérêt légitime comme base légale (art. 6(1)(f) RGPD). Doit démontrer l'équilibre entre l'intérêt du responsable et les droits des personnes." },
  { code: "ROPA", label: "ROPA", color: "#b45309", bg: "#fffbeb", border: "#fcd34d", desc: "Record of Processing Activities — Registre des activités de traitement (art. 30 RGPD). Document central de l'accountability, listant tous les traitements avec leurs caractéristiques essentielles." },
];

/** Aligné avec `TenantDocTypesSettingsController` (backend). */
export const PROOF_DOC_TYPE_CODES = DOC_TYPES.map(d => d.code);

const REF_BY_APP_CODE = (() => {
  const map = {};
  for (const t of hapivotTypesJson.types || []) {
    const code = JSON_ID_TO_APP_CODE[t.id];
    if (code) map[code] = t;
  }
  return map;
})();

/** Métadonnées app + champs référentiel (définition longue, déclencheur, etc.). */
export const DOC_TYPES_WITH_REF = DOC_TYPES.map(dt => ({
  ...dt,
  ref: REF_BY_APP_CODE[dt.code] || null,
  longDesc: REF_BY_APP_CODE[dt.code]?.definition || dt.desc,
}));

export function defaultEnabledByCode() {
  return Object.fromEntries(DOC_TYPES.map(d => [d.code, true]));
}

/** `enabledByCode[code] === false` → masqué dans le formulaire preuve. */
export function getDocTypesForProofForm(enabledByCode) {
  const map = enabledByCode && typeof enabledByCode === "object" ? enabledByCode : defaultEnabledByCode();
  return DOC_TYPES.filter(d => map[d.code] !== false);
}

export function isDocTypeEnabled(code, enabledByCode) {
  const map = enabledByCode && typeof enabledByCode === "object" ? enabledByCode : defaultEnabledByCode();
  return map[code] !== false;
}

export function DocTypeBadge({ code }) {
  const [hov, setHov] = useState(false);
  const dt = DOC_TYPES_WITH_REF.find(d => d.code === code);
  if (!dt) return null;

  const tip = dt.longDesc || dt.desc;

  return (
    <span style={{ position: "relative", display: "inline-block" }} onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}>
      <span style={{ display: "inline-block", padding: "2px 10px", borderRadius: 99, fontSize: 11, fontWeight: 800, letterSpacing: "0.06em", background: dt.bg, color: dt.color, border: `1.5px solid ${dt.border}`, cursor: "help" }}>
        {dt.label}
      </span>
      {hov && (
        <div style={{ position: "absolute", bottom: "calc(100% + 8px)", left: "50%", transform: "translateX(-50%)", background: "#1e293b", color: "#f1f5f9", borderRadius: 8, padding: "10px 14px", fontSize: 12, lineHeight: 1.6, width: 280, zIndex: 200, boxShadow: "0 8px 32px rgba(0,0,0,0.3)", pointerEvents: "none" }}>
          <div style={{ fontWeight: 800, color: dt.color === "#1e293b" ? "#fff" : dt.color, marginBottom: 5 }}>{dt.code} — {dt.label}</div>
          {tip}
          <div style={{ position: "absolute", bottom: -5, left: "50%", transform: "translateX(-50%) rotate(45deg)", width: 10, height: 10, background: "#1e293b", borderRadius: 1 }} />
        </div>
      )}
    </span>
  );
}
